"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyTableRowStateLoading = exports.LegacyTableRowStateFailure = exports.LegacyTableRowStateSuccess = exports.LegacyTableRowColumn = exports.LegacyRowPrimaryKey = exports.LegacyRowValue = exports.LegacySqlQueryOrigin = exports.LegacyMemo = exports.LegacyTableMeta = exports.LegacyColumnMeta = exports.LegacyTag = exports.LegacyNotes = exports.LegacyTableProps = exports.LegacyCanvasProps = exports.LegacySource = exports.LegacyProjectType = exports.LegacyProjectRelation = exports.LegacyProjectColumnRef = exports.LegacyProjectTable = exports.LegacyProjectCheck = exports.LegacyProjectIndex = exports.LegacyProjectUnique = exports.LegacyProjectPrimaryKey = exports.LegacyProjectColumn = exports.LegacyComment = exports.LegacyOrigin = exports.LegacySourceOrigin = exports.LegacySourceKind = exports.LegacyAmlEditor = exports.LegacyJsonRemoteFile = exports.LegacyJsonLocalFile = exports.LegacyPrismaRemoteFile = exports.LegacyPrismaLocalFile = exports.LegacySqlRemoteFile = exports.LegacySqlLocalFile = exports.LegacyDatabaseConnection = exports.DatabaseUrlStorage = exports.LegacyProjectTokenId = exports.LegacyZoomLevel = exports.LegacyLayoutName = exports.LegacyMemoId = exports.LegacyTableRowId = exports.LegacyLineIndex = exports.LegacyLine = exports.LegacyColumnPathStr = exports.LegacySourceName = exports.LegacySourceId = exports.LegacyProjectName = exports.LegacyProjectSlug = exports.LegacyProjectId = void 0;
exports.LegacyProjectInfo = exports.LegacyProjectInfoRemote = exports.LegacyProjectInfoLocal = exports.LegacyProjectStats = exports.LegacyProjectJson = exports.LegacyProject = exports.LegacyProjectVersion = exports.LegacyProjectVisibility = exports.LegacyProjectStorage = exports.LegacySettings = exports.LegacyOrganization = exports.LegacyHerokuResource = exports.LegacyCleverCloudResource = exports.LegacyHerokuId = exports.LegacyCleverCloudId = exports.LegacyPlan = exports.LegacyPlanId = exports.LegacyOrganizationName = exports.LegacyOrganizationSlug = exports.LegacyOrganizationId = exports.LegacyLayout = exports.LegacyGroup = exports.LegacyTableRow = exports.LegacyTableRowState = void 0;
exports.legacyIsLocal = legacyIsLocal;
exports.legacyIsRemote = legacyIsRemote;
exports.legacyParseTableId = legacyParseTableId;
exports.legacyBuildProjectDraft = legacyBuildProjectDraft;
exports.legacyBuildProjectLocal = legacyBuildProjectLocal;
exports.legacyBuildProjectRemote = legacyBuildProjectRemote;
exports.legacyBuildProjectJson = legacyBuildProjectJson;
exports.legacyComputeStats = legacyComputeStats;
exports.sourceToDatabase = sourceToDatabase;
exports.projectTableToEntity = projectTableToEntity;
exports.projectColumnToAttribute = projectColumnToAttribute;
exports.projectTypeFromLegacy = projectTypeFromLegacy;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const common_1 = require("../common");
const legacyDatabase_1 = require("./legacyDatabase");
const zod_2 = require("../zod");
const database_1 = require("../database");
const databaseUrl_1 = require("../databaseUrl");
const llm_1 = require("../llm");
exports.LegacyProjectId = common_1.Uuid;
exports.LegacyProjectSlug = common_1.Slug;
exports.LegacyProjectName = zod_1.z.string();
exports.LegacySourceId = common_1.Uuid;
exports.LegacySourceName = zod_1.z.string();
exports.LegacyColumnPathStr = zod_1.z.string();
exports.LegacyLine = zod_1.z.string();
exports.LegacyLineIndex = zod_1.z.number();
exports.LegacyTableRowId = zod_1.z.number();
exports.LegacyMemoId = zod_1.z.number();
exports.LegacyLayoutName = zod_1.z.string();
exports.LegacyZoomLevel = zod_1.z.number();
exports.LegacyProjectTokenId = common_1.Uuid;
exports.DatabaseUrlStorage = zod_1.z.enum(['memory', 'browser', 'project']);
exports.LegacyDatabaseConnection = zod_1.z.object({
    kind: zod_1.z.literal('DatabaseConnection'),
    engine: database_1.DatabaseKind.optional(),
    url: zod_1.z.string().optional(),
    storage: exports.DatabaseUrlStorage.optional(),
}).strict();
exports.LegacySqlLocalFile = zod_1.z.object({
    kind: zod_1.z.literal('SqlLocalFile'),
    name: zod_1.z.string(),
    size: zod_1.z.number(),
    modified: common_1.Timestamp
}).strict();
exports.LegacySqlRemoteFile = zod_1.z.object({
    kind: zod_1.z.literal('SqlRemoteFile'),
    url: zod_1.z.string(),
    size: zod_1.z.number()
}).strict();
exports.LegacyPrismaLocalFile = zod_1.z.object({
    kind: zod_1.z.literal('PrismaLocalFile'),
    name: zod_1.z.string(),
    size: zod_1.z.number(),
    modified: common_1.Timestamp
}).strict();
exports.LegacyPrismaRemoteFile = zod_1.z.object({
    kind: zod_1.z.literal('PrismaRemoteFile'),
    url: zod_1.z.string(),
    size: zod_1.z.number()
}).strict();
exports.LegacyJsonLocalFile = zod_1.z.object({
    kind: zod_1.z.literal('JsonLocalFile'),
    name: zod_1.z.string(),
    size: zod_1.z.number(),
    modified: common_1.Timestamp
}).strict();
exports.LegacyJsonRemoteFile = zod_1.z.object({
    kind: zod_1.z.literal('JsonRemoteFile'),
    url: zod_1.z.string(),
    size: zod_1.z.number()
}).strict();
exports.LegacyAmlEditor = zod_1.z.object({
    kind: zod_1.z.literal('AmlEditor')
}).strict();
exports.LegacySourceKind = zod_1.z.discriminatedUnion('kind', [exports.LegacyDatabaseConnection, exports.LegacySqlLocalFile, exports.LegacySqlRemoteFile, exports.LegacyPrismaLocalFile, exports.LegacyPrismaRemoteFile, exports.LegacyJsonLocalFile, exports.LegacyJsonRemoteFile, exports.LegacyAmlEditor]);
exports.LegacySourceOrigin = zod_1.z.enum(['import-project', 'sql-source', 'prisma-source', 'json-source']);
exports.LegacyOrigin = zod_1.z.object({
    id: exports.LegacySourceId,
    lines: exports.LegacyLineIndex.array().optional()
}).strict();
exports.LegacyComment = zod_1.z.object({
    text: zod_1.z.string(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectColumn = zod_1.z.object({
    name: legacyDatabase_1.LegacyColumnName,
    type: legacyDatabase_1.LegacyColumnType,
    nullable: zod_1.z.boolean().optional(),
    default: zod_1.z.string().optional(),
    comment: exports.LegacyComment.optional(),
    values: zod_1.z.string().array().optional(),
    columns: zod_1.z.lazy(() => exports.LegacyProjectColumn.array().optional()),
    stats: legacyDatabase_1.LegacyColumnDbStats.optional(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectPrimaryKey = zod_1.z.object({
    name: zod_1.z.string().optional(),
    columns: legacyDatabase_1.LegacyColumnName.array(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectUnique = zod_1.z.object({
    name: zod_1.z.string(),
    columns: legacyDatabase_1.LegacyColumnName.array(),
    definition: zod_1.z.string().optional(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectIndex = zod_1.z.object({
    name: zod_1.z.string(),
    columns: legacyDatabase_1.LegacyColumnName.array(),
    definition: zod_1.z.string().optional(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectCheck = zod_1.z.object({
    name: zod_1.z.string(),
    columns: legacyDatabase_1.LegacyColumnName.array(),
    predicate: zod_1.z.string().optional(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectTable = zod_1.z.object({
    schema: legacyDatabase_1.LegacySchemaName,
    table: legacyDatabase_1.LegacyTableName,
    view: zod_1.z.boolean().optional(),
    definition: zod_1.z.string().optional(),
    columns: exports.LegacyProjectColumn.array(),
    primaryKey: exports.LegacyProjectPrimaryKey.optional(),
    uniques: exports.LegacyProjectUnique.array().optional(),
    indexes: exports.LegacyProjectIndex.array().optional(),
    checks: exports.LegacyProjectCheck.array().optional(),
    comment: exports.LegacyComment.optional(),
    stats: legacyDatabase_1.LegacyTableDbStats.optional(),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectColumnRef = zod_1.z.object({
    table: legacyDatabase_1.LegacyTableId,
    column: legacyDatabase_1.LegacyColumnName
}).strict();
exports.LegacyProjectRelation = zod_1.z.object({
    name: legacyDatabase_1.LegacyRelationName,
    src: exports.LegacyProjectColumnRef,
    ref: exports.LegacyProjectColumnRef,
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacyProjectType = zod_1.z.object({
    schema: legacyDatabase_1.LegacySchemaName,
    name: legacyDatabase_1.LegacyTypeName,
    value: zod_1.z.union([zod_1.z.object({ enum: zod_1.z.string().array() }).strict(), zod_1.z.object({ definition: zod_1.z.string() }).strict()]),
    origins: exports.LegacyOrigin.array().optional()
}).strict();
exports.LegacySource = zod_1.z.object({
    id: exports.LegacySourceId,
    name: exports.LegacySourceName,
    kind: exports.LegacySourceKind,
    content: exports.LegacyLine.array(),
    tables: exports.LegacyProjectTable.array(),
    relations: exports.LegacyProjectRelation.array(),
    types: exports.LegacyProjectType.array().optional(),
    enabled: zod_1.z.boolean().optional(),
    fromSample: zod_1.z.string().optional(),
    createdAt: common_1.Timestamp,
    updatedAt: common_1.Timestamp
}).strict();
exports.LegacyCanvasProps = zod_1.z.object({
    position: common_1.Position,
    zoom: exports.LegacyZoomLevel
}).strict();
exports.LegacyTableProps = zod_1.z.object({
    id: legacyDatabase_1.LegacyTableId,
    position: common_1.Position,
    size: common_1.Size,
    color: common_1.Color,
    columns: legacyDatabase_1.LegacyColumnName.array(),
    selected: zod_1.z.boolean().optional(),
    collapsed: zod_1.z.boolean().optional(),
    hiddenColumns: zod_1.z.boolean().optional()
}).strict();
exports.LegacyNotes = zod_1.z.string();
exports.LegacyTag = zod_1.z.string();
exports.LegacyColumnMeta = zod_1.z.object({
    notes: exports.LegacyNotes.optional(),
    tags: exports.LegacyTag.array().optional()
}).strict();
exports.LegacyTableMeta = zod_1.z.object({
    notes: exports.LegacyNotes.optional(),
    tags: exports.LegacyTag.array().optional(),
    columns: zod_1.z.record(exports.LegacyColumnPathStr, exports.LegacyColumnMeta)
}).strict();
exports.LegacyMemo = zod_1.z.object({
    id: exports.LegacyMemoId,
    content: zod_1.z.string(),
    position: common_1.Position,
    size: common_1.Size,
    color: common_1.Color.optional(),
    selected: zod_1.z.boolean().optional()
}).strict();
exports.LegacySqlQueryOrigin = zod_1.z.object({ sql: zod_1.z.string(), origin: zod_1.z.string(), db: zod_1.z.string() }).strict();
exports.LegacyRowValue = zod_1.z.object({
    column: exports.LegacyColumnPathStr,
    value: legacyDatabase_1.LegacyJsValue
}).strict();
exports.LegacyRowPrimaryKey = exports.LegacyRowValue.array();
exports.LegacyTableRowColumn = zod_1.z.object({
    path: exports.LegacyColumnPathStr,
    value: legacyDatabase_1.LegacyJsValue,
    linkedBy: zod_1.z.record(legacyDatabase_1.LegacyTableId, exports.LegacyRowPrimaryKey.array()).optional()
}).strict();
exports.LegacyTableRowStateSuccess = zod_1.z.object({
    columns: exports.LegacyTableRowColumn.array(),
    startedAt: common_1.Timestamp,
    loadedAt: common_1.Timestamp
}).strict();
exports.LegacyTableRowStateFailure = zod_1.z.object({
    query: exports.LegacySqlQueryOrigin,
    error: zod_1.z.string(),
    startedAt: common_1.Timestamp,
    failedAt: common_1.Timestamp
}).strict();
exports.LegacyTableRowStateLoading = zod_1.z.object({
    query: exports.LegacySqlQueryOrigin,
    startedAt: common_1.Timestamp
}).strict();
exports.LegacyTableRowState = zod_1.z.union([exports.LegacyTableRowStateSuccess, exports.LegacyTableRowStateFailure, exports.LegacyTableRowStateLoading]);
exports.LegacyTableRow = zod_1.z.object({
    id: exports.LegacyTableRowId,
    position: common_1.Position,
    size: common_1.Size,
    source: exports.LegacySourceId,
    table: legacyDatabase_1.LegacyTableId,
    primaryKey: exports.LegacyRowPrimaryKey,
    state: exports.LegacyTableRowState,
    hidden: exports.LegacyColumnPathStr.array().optional(),
    showHiddenColumns: zod_1.z.boolean().optional(),
    selected: zod_1.z.boolean().optional(),
    collapsed: zod_1.z.boolean().optional()
}).strict();
exports.LegacyGroup = zod_1.z.object({
    name: zod_1.z.string(),
    tables: legacyDatabase_1.LegacyTableId.array(),
    color: common_1.Color,
    collapsed: zod_1.z.boolean().optional()
}).strict();
exports.LegacyLayout = zod_1.z.object({
    canvas: exports.LegacyCanvasProps.optional(),
    tables: exports.LegacyTableProps.array(),
    tableRows: exports.LegacyTableRow.array().optional(),
    groups: exports.LegacyGroup.array().optional(),
    memos: exports.LegacyMemo.array().optional(),
    createdAt: common_1.Timestamp,
    updatedAt: common_1.Timestamp
}).strict();
exports.LegacyOrganizationId = common_1.Uuid;
exports.LegacyOrganizationSlug = common_1.Slug;
exports.LegacyOrganizationName = zod_1.z.string();
exports.LegacyPlanId = zod_1.z.enum(['free', 'solo', 'team', 'enterprise', 'pro']);
exports.LegacyPlan = zod_1.z.object({
    id: exports.LegacyPlanId,
    name: zod_1.z.string(),
    data_exploration: zod_1.z.boolean(),
    colors: zod_1.z.boolean(),
    aml: zod_1.z.boolean(),
    schema_export: zod_1.z.boolean(),
    ai: zod_1.z.boolean(),
    analysis: zod_1.z.string(),
    project_export: zod_1.z.boolean(),
    projects: zod_1.z.number().nullable(),
    project_dbs: zod_1.z.number().nullable(),
    project_layouts: zod_1.z.number().nullable(),
    layout_tables: zod_1.z.number().nullable(),
    project_doc: zod_1.z.number().nullable(),
    project_share: zod_1.z.boolean(),
    streak: zod_1.z.number(),
}).strict();
exports.LegacyCleverCloudId = common_1.Uuid;
exports.LegacyHerokuId = common_1.Uuid;
exports.LegacyCleverCloudResource = zod_1.z.object({ id: exports.LegacyCleverCloudId }).strict();
exports.LegacyHerokuResource = zod_1.z.object({ id: exports.LegacyHerokuId }).strict();
exports.LegacyOrganization = zod_1.z.object({
    id: exports.LegacyOrganizationId,
    slug: exports.LegacyOrganizationSlug,
    name: exports.LegacyOrganizationName,
    plan: exports.LegacyPlan,
    logo: zod_1.z.string().url(),
    description: zod_1.z.string().optional(),
    clever_cloud: exports.LegacyCleverCloudResource.optional(),
    heroku: exports.LegacyHerokuResource.optional(),
}).strict();
exports.LegacySettings = zod_1.z.object({
    findPath: zod_1.z.object({
        maxPathLength: zod_1.z.number().optional(),
        ignoredTables: zod_1.z.string().optional(),
        ignoredColumns: zod_1.z.string().optional()
    }).strict().optional(),
    defaultSchema: legacyDatabase_1.LegacySchemaName.optional(),
    removedSchemas: legacyDatabase_1.LegacySchemaName.array().optional(),
    removeViews: zod_1.z.boolean().optional(),
    removedTables: zod_1.z.string().optional(),
    hiddenColumns: zod_1.z.object({
        list: zod_1.z.string().optional(),
        max: zod_1.z.number().optional(),
        props: zod_1.z.boolean().optional(),
        relations: zod_1.z.boolean().optional()
    }).strict().optional(),
    columnOrder: zod_1.z.enum(['sql', 'property', 'name', 'type']).optional(),
    relationStyle: zod_1.z.enum(['Bezier', 'Straight', 'Steps']).optional(),
    columnBasicTypes: zod_1.z.boolean().optional(),
    collapseTableColumns: zod_1.z.boolean().optional(),
    llm: zod_1.z.object({
        key: llm_1.OpenAIKey,
        model: llm_1.OpenAIModel,
    }).strict().optional(),
}).strict();
exports.LegacyProjectStorage = zod_1.z.enum(['local', 'remote']);
exports.LegacyProjectVisibility = zod_1.z.enum(['none', 'read', 'write']);
exports.LegacyProjectVersion = zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal(2)]);
exports.LegacyProject = zod_1.z.object({
    organization: exports.LegacyOrganization.optional(),
    id: exports.LegacyProjectId,
    slug: exports.LegacyProjectSlug,
    name: exports.LegacyProjectName,
    description: zod_1.z.string().optional(),
    sources: exports.LegacySource.array(),
    ignoredRelations: zod_1.z.record(exports.LegacyColumnPathStr.array()).optional(),
    notes: zod_1.z.record(zod_1.z.string()).optional(),
    metadata: zod_1.z.record(legacyDatabase_1.LegacyTableId, exports.LegacyTableMeta).optional(),
    usedLayout: exports.LegacyLayoutName.optional(),
    layouts: zod_1.z.record(exports.LegacyLayoutName, exports.LegacyLayout),
    tableRowsSeq: zod_1.z.number().optional(),
    settings: exports.LegacySettings.optional(),
    storage: exports.LegacyProjectStorage,
    visibility: exports.LegacyProjectVisibility,
    createdAt: common_1.Timestamp,
    updatedAt: common_1.Timestamp,
    version: exports.LegacyProjectVersion
}).strict().describe('LegacyProject');
exports.LegacyProjectJson = exports.LegacyProject.omit({ organization: true, id: true, storage: true, visibility: true, createdAt: true, updatedAt: true }).extend({ _type: zod_1.z.literal('json') }).strict().describe('LegacyProjectJson');
exports.LegacyProjectStats = zod_1.z.object({
    nbSources: zod_1.z.number(),
    nbTables: zod_1.z.number(),
    nbColumns: zod_1.z.number(),
    nbRelations: zod_1.z.number(),
    nbTypes: zod_1.z.number(),
    nbComments: zod_1.z.number(),
    nbLayouts: zod_1.z.number(),
    nbNotes: zod_1.z.number(),
    nbMemos: zod_1.z.number()
}).strict().describe('LegacyProjectStats');
exports.LegacyProjectInfoLocal = exports.LegacyProjectStats.extend({
    organization: exports.LegacyOrganization.optional(),
    id: exports.LegacyProjectId,
    slug: exports.LegacyProjectSlug,
    name: exports.LegacyProjectName,
    description: zod_1.z.string().optional(),
    storage: zod_1.z.literal(exports.LegacyProjectStorage.enum.local),
    visibility: exports.LegacyProjectVisibility,
    encodingVersion: exports.LegacyProjectVersion,
    createdAt: common_1.Timestamp,
    updatedAt: common_1.Timestamp
}).strict();
exports.LegacyProjectInfoRemote = exports.LegacyProjectInfoLocal.omit({ storage: true }).extend({ storage: zod_1.z.literal(exports.LegacyProjectStorage.enum.remote) }).strict();
exports.LegacyProjectInfo = zod_1.z.discriminatedUnion('storage', [exports.LegacyProjectInfoLocal, exports.LegacyProjectInfoRemote]);
function legacyIsLocal(p) {
    return p.storage === exports.LegacyProjectStorage.enum.local;
}
function legacyIsRemote(p) {
    return p.storage === exports.LegacyProjectStorage.enum.remote;
}
function legacyParseTableId(id) {
    const [schema, table] = id.split(".");
    return table === undefined ? { schema: "", table: schema } : { schema, table };
}
function legacyBuildProjectDraft(id, { _type, ...p }) {
    return (0, zod_2.zodParse)(exports.LegacyProject)({
        ...p,
        id,
        slug: id,
        storage: exports.LegacyProjectStorage.enum.local,
        visibility: exports.LegacyProjectVisibility.enum.none,
        createdAt: Date.now(),
        updatedAt: Date.now()
    }).getOrThrow();
}
function legacyBuildProjectLocal(info, { _type, ...p }) {
    return (0, zod_2.zodParse)(exports.LegacyProject)({
        ...p,
        organization: info.organization,
        id: info.id,
        storage: exports.LegacyProjectStorage.enum.local,
        visibility: exports.LegacyProjectVisibility.enum.none,
        createdAt: info.createdAt,
        updatedAt: info.updatedAt
    }).getOrThrow();
}
function legacyBuildProjectRemote(info, { _type, ...p }) {
    return (0, zod_2.zodParse)(exports.LegacyProject)({
        ...p,
        organization: info.organization,
        id: info.id,
        slug: info.slug,
        storage: exports.LegacyProjectStorage.enum.remote,
        visibility: info.visibility,
        createdAt: info.createdAt,
        updatedAt: info.updatedAt
    }).getOrThrow();
}
function legacyBuildProjectJson({ organization, id, storage, visibility, createdAt, updatedAt, ...p }) {
    return (0, zod_2.zodParse)(exports.LegacyProjectJson)({ ...p, _type: 'json' }).getOrThrow();
}
function legacyComputeStats(p) {
    // should be the same as `tables`, `relations` and `types` in src/Models/Project.elm
    const tables = (0, utils_1.groupBy)(p.sources.flatMap(s => s.tables), t => `${t.schema}.${t.table}`);
    const relations = (0, utils_1.groupBy)(p.sources.flatMap(s => s.relations), r => `${r.src.table}.${r.src.column}->${r.ref.table}.${r.ref.column}`);
    const types = (0, utils_1.groupBy)(p.sources.flatMap(s => s.types || []), t => `${t.schema}.${t.name}`);
    return (0, zod_2.zodParse)(exports.LegacyProjectStats)({
        nbSources: p.sources.length,
        nbTables: Object.keys(tables).length,
        nbColumns: Object.values(tables).map(same => Math.max(...same.map(t => t.columns.length))).reduce((acc, cols) => acc + cols, 0),
        nbRelations: Object.keys(relations).length,
        nbTypes: Object.keys(types).length,
        nbComments: p.sources.flatMap(s => s.tables.flatMap(t => [t.comment].concat(t.columns.map(c => c.comment)).filter(c => !!c))).length,
        nbLayouts: Object.keys(p.layouts).length,
        nbNotes: Object.keys(p.notes || {}).length,
        nbMemos: Object.values(p.layouts).flatMap(l => l.memos || []).length,
    }).getOrThrow();
}
function sourceToDatabase(s) {
    return (0, utils_1.removeEmpty)({
        entities: s.tables.map(projectTableToEntity),
        relations: s.relations.map(legacyDatabase_1.relationFromLegacy),
        types: s.types?.map(projectTypeFromLegacy),
        stats: (0, utils_1.removeUndefined)({
            name: s.name,
            kind: s.kind.kind === 'DatabaseConnection' ? (s.kind.engine ? s.kind.engine : s.kind.url ? (0, databaseUrl_1.parseDatabaseUrl)(s.kind.url).kind : undefined) : undefined
        })
    });
}
function projectTableToEntity(t) {
    return (0, utils_1.removeUndefined)({
        database: undefined,
        catalog: undefined,
        schema: t.schema || undefined,
        name: t.table,
        kind: t.view ? 'view' : undefined,
        def: t.definition,
        attrs: t.columns.map(projectColumnToAttribute),
        pk: t.primaryKey ? (0, legacyDatabase_1.primaryKeyFromLegacy)(t.primaryKey) : undefined,
        indexes: (t.uniques || []).map(legacyDatabase_1.uniqueFromLegacy).concat((t.indexes || []).map(legacyDatabase_1.indexFromLegacy)),
        checks: t.checks?.map(legacyDatabase_1.checkFromLegacy),
        doc: t.comment?.text,
        stats: t.stats ? (0, legacyDatabase_1.tableDbStatsFromLegacy)(t.stats) : undefined,
        extra: undefined,
    });
}
function projectColumnToAttribute(c) {
    return (0, utils_1.removeEmpty)({
        name: c.name,
        type: c.type,
        null: c.nullable,
        gen: undefined,
        default: c.default,
        attrs: c.columns?.map(projectColumnToAttribute),
        doc: c.comment?.text,
        stats: (0, utils_1.removeUndefined)({
            nulls: c.stats?.nulls,
            bytesAvg: c.stats?.bytesAvg,
            cardinality: c.stats?.cardinality,
            commonValues: c.stats?.commonValues?.map(v => ({ value: (0, legacyDatabase_1.columnValueFromLegacy)(v.value), freq: v.freq })),
            distinctValues: c.values?.map(legacyDatabase_1.columnValueFromLegacy),
            histogram: c.stats?.histogram?.map(legacyDatabase_1.columnValueFromLegacy),
            min: undefined,
            max: undefined,
        })
    });
}
function projectTypeFromLegacy(t) {
    if ('enum' in t.value) {
        return (0, utils_1.removeUndefined)({ schema: t.schema || undefined, name: t.name, values: t.value.enum || undefined });
    }
    else {
        return (0, utils_1.removeUndefined)({ schema: t.schema || undefined, name: t.name, definition: t.value.definition });
    }
}
//# sourceMappingURL=legacyProject.js.map